import 'zone.js';

// keycloak-js 26 uses Promise.withResolvers (ES2024). zone.js replaces the global
// Promise with ZoneAwarePromise, which does not have it, so every token refresh threw
// "Promise.withResolvers is not a function" and the session dropped after three tries.
// Must run after the zone.js import above so it lands on the Promise Keycloak sees.
type WithResolvers = <T>() => { promise: Promise<T>; resolve: (value: T | PromiseLike<T>) => void; reject: (reason?: unknown) => void };
const promiseCtor = Promise as unknown as { withResolvers?: WithResolvers };
if (typeof promiseCtor.withResolvers !== 'function') {
    promiseCtor.withResolvers = function withResolvers<T>() {
        let resolve!: (value: T | PromiseLike<T>) => void;
        let reject!: (reason?: unknown) => void;
        const promise = new Promise<T>((res, rej) => {
            resolve = res;
            reject = rej;
        });
        return { promise, resolve, reject };
    };
}
